import type {
  SupplierRelationshipProductItemDiscountUpdateRequestType,
  SupplierRelationshipProductItemDiscountUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useSupplierRelationshipProductItemDiscountUpdate = (
  productItemDiscountId: number,
) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (
      data: SupplierRelationshipProductItemDiscountUpdateRequestType,
    ) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `supplier-relationship-product-item-discounts/${productItemDiscountId}`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data)
            .data as SupplierRelationshipProductItemDiscountUpdateResponseType,
      ),

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.SupplierRelationshipProductItemDiscounts,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Products],
      });
    },
  });
};
